import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function AboutHome() {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate('/About');
      };


  return (
    <section id="about" className="about section">
        <div className="container section-title aos-init aos-animate" data-aos="fade-up">
            <h2>About</h2>
            <p>About Us<br /></p>
        </div>
        <div className="container">
            <div className="row gy-4">
                <div className="col-lg-6 content aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                <p>
                    The name of our long-standing enterprise hints of our area of expertise.<br />We <span className="rw-title-name">RAILING WORLD</span>, are a railing manufacturer and supplier, widely accepted for introducing matchless quality and designer array of railing; in Aluminum, stainless steel and glass.
                </p>
                <ul>
                    <li><i className="bi bi-check2-circle"></i> <span>Customized Solutions.</span></li>
                    <li><i className="bi bi-check2-circle"></i> <span>Durability &amp; Safety Focus.</span></li>
                    <li><i className="bi bi-check2-circle"></i> <span>End-to-End Support.</span></li>
                </ul>
                </div>

                <div className="col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                <p>We are a perfectionist in introducing uniquely designed Aluminum glass railing, Modular railing, Balcony railing, stainless steel balcony railing, Glass stair railing, Glass deck railing and other railing. Each piece in our portfolio excellently showcases creativity of our designers, who put their imagination and strength in designing railing. </p>
                <button onClick={handleClick} className="read-more" style={{background:'none',border:'none',padding:0,cursor:'pointer'}}><span>Read More</span><i className="bi bi-arrow-right"></i></button>
                </div>
            </div>
        </div>
    </section>
  )
}